import { DownpaymentIcon } from "../../../atoms/icons/downpayment";
import React, { useContext } from "react";
import { LookingToContext } from '../../../context/LookingToContext';

export const Downpayment = ({ downpayment }) => {
  const lookingTo = useContext(LookingToContext)
  
  if(lookingTo === "Refinance") {
    return null;
  }
  return (
    <div className="irq-nav-wrapper">
      <DownpaymentIcon className="margin-right" fill="white" />
      <span className="top-stats-text">Downpayment:</span>
      <div className="margin-left">
        <span className="large"> $</span>
        <span className="large bold">
          {parseFloat(downpayment).toLocaleString()}
        </span>
      </div>
    </div>
  );
};
